// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock___tc_M","validationTips":"StatementDescriptor_validationTips__3H2Ql"};